<template>
  <div class="timeline-container">
    <h2 class="timeline-title">Our Partner Program & Opportunities</h2>
    <div class="timeline">
      <div
        v-for="(item, index) in timelineItems"
        :key="index"
        :class="['timeline-item', index % 2 === 0 ? 'left' : 'right']"
      >
        <div class="timeline-content">
          <div class="icon"><i :class="item.iconClass"></i></div>
          <h3>{{ item.title }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlternatingTimeline",
  data() {
    return {
      timelineItems: [
        { title: "Due Diligence", iconClass: "fas fa-star" },
        { title: "Compliance", iconClass: "fas fa-star" },
        { title: "Agreement", iconClass: "fas fa-star" },
        { title: "Capability", iconClass: "fas fa-star" },
        { title: "Handshaking", iconClass: "fas fa-star" },
      ],
    };
  },
};
</script>

<style scoped>
.timeline-container {
  padding: 40px 20px;
  max-width: 900px;
  margin: 0 auto;
  position: relative;
}

.timeline-title {
  text-align: center;
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 60px;
}

.timeline {
  position: relative;
  padding: 20px 0;
}

.timeline::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  width: 3px;
  background-color: #1f55ba;
  transform: translateX(-50%);
  z-index: 1;
}

.timeline-item {
  width: 50%;
  padding: 20px;
  position: relative;
  z-index: 2;
}

.timeline-item.left {
  left: 0;
  text-align: right;
}

.timeline-item.right {
  left: 50%;
  text-align: left;
}

.timeline-content {
  background: #f5f5f5;
  padding: 16px 24px;
  border-radius: 8px;
  position: relative;
  display: inline-block;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.timeline-content h3 {
  margin: 8px 0 0;
  font-size: 16px;
  color: #1f55ba;
}

.icon {
  background-color: #1f55ba;
  color: white;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  margin-bottom: 6px;
}
</style>
